var map = {
	"./bg_8BitTT 19th Hole.png": 9066,
	"./bg_8BitTT Gold.png": 4816,
	"./bg_8BitTT Purple.png": 6814,
	"./bg_8BitTT Silver.png": 1281,
	"./bg_Bunker Beach.png": 243,
	"./bg_Chart Bullish.png": 3221,
	"./bg_Charts Bearish.png": 3803,
	"./bg_Golf Course.png": 498,
	"./bg_Night City.png": 5307,
	"./bg_Royal Woods.png": 6263,
	"./bg_Stars.png": 5563,
	"./bg_Sunrise City.png": 4555,
	"./bg_Sunrise Hills.png": 3508,
	"./bg_Sunrise Waves.png": 313,
	"./bg_Tarnation Badlands.png": 6733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3043;